import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { compose, withHandlers, lifecycle, withState } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Typography from '@material-ui/core/Typography';
import { MenuItem, TextField } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import { getAccounts } from '../../actions/Accounts';
import {
  listBatchGochiCharge,
  validateBatchGochiCharge,
  batchGochiChargeImportFile,
  GET_BATCH_GOCHI_CHARGE_SUCCESS,
  VALIDATE_BATCH_GOCHI_CHARGE_SUCCESS,
  ADD_BATCH_GOCHI_CHARGE_IMPORT_FILE_SUCCESS
} from '../../actions/Gochis';
import '../../stylesheets/csv.css';
import SearchButton from '../../components/atoms/SearchButton';
import BatchGochiChargeTable from '../organisms/BatchGochiChargeTable';
import batchGochiChargeStatuses from '../../constants/BatchGochiChargeStatuses';
import BatchGochiChargeButton from '../../components/atoms/BatchGochiChargeButton';

const styles = theme => ({
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  pageDiscriptionDiv: {
    paddingLeft: 26,
    paddingTop: 2,
    textAlign: 'left'
  },
  mainPaper: {
    position: 'relative',
    margin: 20
  },
  zoom: {
    position: 'relative',
    left: -10,
    top: 20
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  searchForm: {
    padding: '10px 26px 10px 26px',
    maxWidth: 700
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  buttonGroupLeft: {
    textAlign: 'left'
    // float: 'left'
  },
  buttonRight: {
    textAlign: 'right'
  },
  buttonGroupRight: {
    textAlign: 'right'
  },
  textInput100: {
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  flex: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  inputContainer: {
    padding: 30,
    display: 'flex',
    flexDirection: 'column-reverse'
  },
  flexColumnRevert: {
    display: 'flex',
    flexDirection: 'column-reverse'
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  searchFormContainer: {
    backgroundColor: '#fff',
    margin: 15
  },
  horizotalLine: {
    borderBottom: '15px solid #DBDBDB'
  }
});

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getAccounts,
          listBatchGochiCharge,
          validateBatchGochiCharge,
          batchGochiChargeImportFile
        },
        dispatch
      )
    })
  ),
  withState('file', 'setFile', null),
  withState('resultMessage', 'setResultMessage', ''),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('loading', 'updateLoading', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('isAddSuccess', 'updateIsAddSuccess', false),
  withState('gochiBillNo', 'setGochiBillNo', null),
  withState('batchLogId', 'setBatchLogId', null),
  withState('createdAt', 'setCreatedAt', null),
  withState('status', 'setStatus', ''),
  withState('page', 'setPage', 1),
  withState('openTable', 'updateOpenTable', true),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('openConfirm', 'updateOpenConfirm', false),
  withState('validateData', 'setValidateData', {}),
  withHandlers({
    checkSession: props => data => {
      console.log(data);
      if (
        data.error === true &&
        typeof data.payload !== 'undefined' &&
        data.payload.status === 403
      ) {
        sendLogin(props);
      }
      return data;
    }
  }),
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    },
    handleChangePage: props => (event, page, limit) => {
      const limitNum = limit || props.rowsPerPage;
      console.log('HANDLE CHANGE PAGE');
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      props.setPage(page);

      const searchKey = {
        gochiBillNo: props.gochiBillNo,
        batchLogId: props.batchLogId,
        createdAt: props.createdAt,
        status: props.status,
        page,
        limit: limitNum
      };

      props.updateLoading(true);
      // props.updateOpenProgress(true);
      props.actions.listBatchGochiCharge(searchKey).then(data => {
        props.checkSession(data);
        if (data.type === GET_BATCH_GOCHI_CHARGE_SUCCESS) {
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
          props.updateOpenTable(true);
        } else {
          props.setResultMessage('エラーが発生しました！');
          props.updateLoading(false);
        }
      });
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);
        this.props.handleChangePage(null, 1, this.props.rowsPerPage);
      });
    }
  })
);

const Main = enhance(
  ({
    actions,
    account,
    classes,
    file,
    setFile,
    resultMessage,
    setResultMessage,
    checkSession,
    openDrawer,
    updateOpenDrawer,
    openProgress,
    openTable,
    updateOpenTable,
    updateOpenProgress,
    loading,
    updateLoading,
    batchLogId,
    setBatchLogId,
    createdAt,
    setCreatedAt,
    status,
    setStatus,
    handleChangePage,
    page,
    rowsPerPage,
    setRowsPerPage,
    openConfirm,
    updateOpenConfirm,
    validateData,
    setValidateData,
    gochiBillNo,
    setGochiBillNo
  }) => {
    const progress = {
      loading,
      updateLoading,
      openProgress,
      updateOpenProgress,
      setResultMessage
    };

    const searchAction = async () => {
      updateOpenTable(true);
      handleChangePage(null, 1, rowsPerPage);
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
      updateLoading(true);
      handleChangePage(null, page, rowsPerPage);
    };

    const validateAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const formData = new FormData();
      if (file) {
        formData.append('file', file, file.name);
        console.log(file);
        const uploadedFile = await actions
          .validateBatchGochiCharge(formData)
          .then(data => checkSession(data));

        if (uploadedFile.type === VALIDATE_BATCH_GOCHI_CHARGE_SUCCESS) {
          setValidateData(uploadedFile.payload);
          updateOpenConfirm(true);
          updateLoading(false);
        } else {
          setResultMessage('エラーが発生しました！');
          updateLoading(false);
        }
      } else {
        setResultMessage('ファイルが選択されていません。');
        updateLoading(false);
      }
      updateOpenProgress(false);
    };

    const registerAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const formData = new FormData();
      if (file) {
        formData.append('file', file, file.name);
        console.log(file);
        const uploadedFile = await actions
          .batchGochiChargeImportFile(formData)
          .then(data => checkSession(data));

        if (uploadedFile.type === ADD_BATCH_GOCHI_CHARGE_IMPORT_FILE_SUCCESS) {
          if (uploadedFile.payload.code === 200) {
            setResultMessage('データをインポートしました');
          } else {
            setResultMessage(
              'データのインポートに失敗しました。もう一度やり直してください'
            );
          }
          updateLoading(false);
          updateOpenConfirm(false);
        } else {
          setResultMessage(
            'データのインポートに失敗しました。もう一度やり直してください'
          );
          updateLoading(false);
          updateOpenConfirm(false);
        }
      } else {
        setResultMessage('ファイルが選択されていません。');
        updateLoading(false);
      }
    };

    return (
      <div className={classes.root}>
        <Header
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            一括チャージ（地域通貨チケット）
          </Typography>
        </div>
        <Paper>
          <div className={classes.searchFormContainer}>
            <div className={classes.flex}>
              <div className={classes.searchForm}>
                <TextField
                  label="領収書NO"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={gochiBillNo}
                  onChange={e => {
                    setGochiBillNo(e.target.value);
                  }}
                />
                <TextField
                  label="一括チャージID"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={batchLogId}
                  onChange={e => {
                    setBatchLogId(e.target.value);
                  }}
                />
                <TextField
                  label="インポート日"
                  type="date"
                  className={classes.textField}
                  margin="normal"
                  value={createdAt}
                  onChange={e => {
                    setCreatedAt(e.target.value);
                  }}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
                <TextField
                  select
                  label="ステータス"
                  className={classes.textField}
                  margin="normal"
                  value={status}
                  onChange={e => {
                    setStatus(e.target.value);
                  }}
                >
                  {batchGochiChargeStatuses.map(item => {
                    return (
                      <MenuItem key={item.id} value={item.value}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </TextField>
                <div className={classes.buttonGroupLeft}>
                  <SearchButton onClickAction={searchAction} />
                </div>
              </div>
              <div className={`${classes.flex} ${classes.inputContainer}`}>
                <a
                  href="data:@file/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,UEsDBBQABgAIAAAAIQCEreWPfgEAAEgFAAATAAgCW0NvbnRlbnRfVHlwZXNdLnhtbCCiBAIooAACAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACsVMlOwzAQvSPxD5GvqHHLASHUlAPLESq1fMAQTxOriW15pqX9eybuIoSgpaKXRLE9b5n4zfB+1TbZEiNZ7wo1yPsqQ1d6Y11VqLfpc+9WZcTgDDTeYaHWSOp+dHkxnK4DUibVjgpVM4c7ramssQXKfUAnOzMfW2D5jJUOUM6hQn3d79/o0jtGxz3uMNRo+IgzWDScPa1keaPk3TqVPWzOdVSFghAaWwKLUL105htJz89mtkTjy0Ur0DmFiGCoRuS2yUO0whgnyCzGSOkfOSM2dBrp1lUulUkY1TbQlVj/haHb+d3Vtu5Vfke0BrMxRH6BVrzrVaM/fJy/ez/PD4Oc2prUorwF63a6D/Cnw6TTa3BmIZ2/BHxEB8sdQ52e/5eQYI4QEq8bpHO3PYEeY64hopmw3N7q7AK+Yh/SIZEaRx9IUhvx9C7sItJV94IAYWSL+5D8dNn2jBL5f7cdu5li0PyRW4LWIoMBhgNJlekEcd2FXKc5OPoEAAD//wMAUEsDBBQABgAIAAAAIQC1VTAj9AAAAEwCAAALAAgCX3JlbHMvLnJlbHMgogQCKKAAAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArJJNT8MwDIbvSPyHyPfV3ZAQQkt3QUi7IVR+gEncD7WNoyQb3b8nHBBUGoMDR3+9fvzK2908jerIIfbiNKyLEhQ7I7Z3rYaX+nF1ByomcpZGcazhxBF21fXV9plHSnkodr2PKqu4qKFLyd8jRtPxRLEQzy5XGgkTpRyGFj2ZgVrGTVneYviuAdVCU+2thrC3N6Dqk8+bf9eWpukNP4g5TOzSmRXIc2Jn2a58yGwh9fkaVVNoOWmwYp5yOiJ5X2RswPNEm78T/XwtTpzIUiI0Evgyz0fHJaD1f1q0NPHLnXnENwnDq8jwyYKLH6jeAQAA//8DAFBLAwQUAAYACAAAACEAmKxUpxYBAAArAwAAGgAIAXhsL19yZWxzL3dvcmtib29rLnhtbC5yZWxzIKIEASigAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArJLPSsRADMbvgu9Q5m6nFVxFtt3LIuxV1wcYp+kf2pmUSVbt2xsLbq0s9dLLQBLm+34J33b36broHQI16DOVxomKwFssGl9l6vX4dPOgImLjC9Ohh0wNQGqXX19tn6EzLJ+obnqKRMVTpmrm/lFrsjU4QzH24GVSYnCGpQyV7o1tTQX6Nkk2OvzWUPlMMzoUmQqHQvyPQy/O/2tjWTYW9mhPDjxfsNBUmwDFCwdZj0TYhAo4U7N2LMRKX4a5XxWGh06uOVGM9ZJ9uqb9B4aWagCeCM4tkkvJJF2C2awJwxIYmEDGUo/vIsPdHwZ7Ikb3E78KseogtujmSdPfe74htg7YFIbNZHzuSAD0LOL5FwAAAP//AwBQSwMEFAAGAAgAAAAhALipIOpcAgAAggQAAA8AAAB4bC93b3JrYm9vay54bWykVMtO3DAU3VfqP1jeQyZToBBNguhQyiBAUF5tNRuP40ksbN9gOzPDuqrUP2DbX+i2/0PVz+iNQ4CWDVU38Ss+vudhDzYXWpGZsE6CSWm83KNEGA65NEVKz053ltYpcZ6ZnCkwIqXXwtHN7OWLwRzs5QTgkiCAcSktva+SKHK8FJq5ZaiEwZUpWM08Dm0RucoKlrtSCK9V1O/11iLNpKEtQmKfgwHTqeRiG3ithfEtiBWKeSzflbJyHZrmz4HTzF7W1RIHXSHERCrprwMoJZono8KAZROFtBfxaoeM3SfQWnILDqZ+GaGitsgnfONeFMct5WwwlUqct7ITVlWHTDenKEoUc/5tLr3IU7qGQ5iLPyZsXb2ppcLVeGWl36NRdm/FkcUB1r2lvLCGeTEE41GmO4H/V5KAPSwBDSDvxVUtrUDfG2WyAX4ZT9jEHTFfktqqlA6T8ZlDhuNdYKY4PBhvw9wowASMH0nJnvr0D2Iy3vCPkHNbV9v/m382aIJ6LsXcPYjVDMniQpoc5inF2F8/6s/D9IXMfZnS/qveCq63c7tCFqVP6Ua8sRrOfgQdoo1HhJaYYOntj5tfX29+fv5y++073qQm/KPGO0psIrFjR3kccLrNnCl+ZEnTND8Gg8XC7zufDbBFbWVK3wEUSpw0aG5YOw96m3l2l6cY/SggaQEfVh8OxChbqE3urayafSeywLTUFhO4deAXr3WxOJ/M9vZHW+bYzmBn4xNc9GdX+uP66YfjNO3cK+D+HvBQAwDe+O4BKEKJ4T4Eflg7utMxibrnI/sNAAD//wMAUEsDBBQABgAIAAAAIQC4ShWWJgEAALUBAAAUAAAAeGwvc2hhcmVkU3RyaW5ncy54bWyEkM1Kw0AUhfeC7zDMShfpzKSm2pCkC0G6qSt9gJCMbaAzE3MnYpeahULxD0QUBRUX6ht04duEVPIWjoqbVvFyNuee83Hhep19MUR7PINESR+zBsWIy0jFiez7eHtrw1rDCHQo43CoJPfxiAPuBIsLHoBGhpXg44HWqUsIRAMuQmiolEuT7KhMhNrYrE8gzXgYw4BzLYbEprRFRJhIjCKVS+1jcySXyW7O13984EESeDrYVB7RgUc+3ffGpnbTorbFVhCl7pf+qtgUMeY6baO5SpMy1mbUcVZbs1n9cF2dnU5vJ/PHy+KgLJ7K4q08nNRHF/XjySxcHb++X77UV+PqeYyWRmasXs+KY9TtukK4AMu/E9O7+/rm/D+CmLcHHwAAAP//AwBQSwMEFAAGAAgAAAAhADttMkvBAAAAQgEAACMAAAB4bC93b3Jrc2hlZXRzL19yZWxzL3NoZWV0MS54bWwucmVsc4SPwYrCMBRF9wP+Q3h7k9aFDENTNyK4VecDYvraBtuXkPcU/XuzHGXA5eVwz+U2m/s8qRtmDpEs1LoCheRjF2iw8HvaLb9BsTjq3BQJLTyQYdMuvpoDTk5KiceQWBULsYVRJP0Yw37E2bGOCamQPubZSYl5MMn5ixvQrKpqbfJfB7QvTrXvLOR9V4M6PVJZ/uyOfR88bqO/zkjyz4RJOZBgPqJIOchF7fKAYkHrd/aea30OBKZtzMvz9gkAAP//AwBQSwMEFAAGAAgAAAAhAM2zKROgAwAAlQ4AABMAAAB4bC90aGVtZS90aGVtZTEueG1szFddb9owFH2ftP8Q5X3lGwoqVC0U7WHTpLFpzyZxPlrHiWzTrv9+19f5sAmMrqNS4YU4x9fH91yfa66uf2fMe6RCpjmf+72Lru9RHuRhyuO5//PH+tOl70lFeEhYzuncf6bSv158/HBFZiqhGfVgPpczMvcTpYpZpyMDGCbyIi8oh3dRLjKi4FHEnVCQJ4ibsU6/2x13MpJy3+Mkg7CbhFIl/UUV9o5BbK6kHgiY2OigtI0NH3oaIUW8XTLhPRI297v48TuLqw6ZlQCm2rg1fkpcCQgf+qfiIYCpNm4vHgJIEMAu2msPh5P+cliubYHMz3bsu9VkNeg5eCv+oMX5ZqS/Dh5BJv6whV+vl5A1B48ggx+18KPb6e3KjY8ggx+38JPuzWo4ceIjKGEpf2hnfDQeLKvd1pAoZ59PwxsUqF9Xjl4iyrk6VkcZuc/FGgAayIhKuaeeCxqRAGpzSVi6FalmT2aUHHsTyMNvgIcTPkv5m67VhIeVm01jCjI3A9+iKA0onrooZWyjnhn9IjEJMmdpuIZBVAePX33CigR+lmI6uFgQnOOJXP1KVbJJSAEJ7OEKsSxDx9IrcgkHFYfRL+hebJRhl33NQ3Omez19qI0CkqhmvDuqx0E0ZdDjSVPMdXi0gxgNpSKg5/4LCWsxl8TgAIlJNQgq/I0E7uwsLKYHWFzq8JVUlYp1KoBarQocLY9o0x8NjYF6MiCMhlon46WVulqcsyp9LJnMroAu9IyyAhqlp5rr0e3p3ZlSe4HSDgmr3FwSVhkmJKRlddod55xaTxtJHXo6FdVpaGhMLt9Ca20ie97AuO0UjHtPc388GMHVISDF3I/AQOFnVkDtSB77HmEx3C0CJcyBf42zFEKqFZGJSTiajnGDLFVUeCzN5r7efl0NjKOHILdeHwzh3ZKbgq28N3IguisyjSIaKFt2awT7IgLA4Y1XHHyL018P1jPzHci9ScInb8t24juBEhtNejqBYSoVtBqTzTAVlpE19bfXmErbPXB71GsRViSk7Ci2mRs4mmhNB5/MprHLQQKdFLjPZSPcxrrB/nfXPd2q9W4s02x6puMqumseNtO3a/IWq6aJOqyMdePdSzZeN628Dgr1YJc40XVf0BAsas1iDjXNuG3D2rPLUZfaGS8EVibGR/JW94iDmXht54d5+1WrG0R1r8RjgP8L7T9w+fYezGMF1+kdU9Jco38rQeDSZy7ktW3g1MUfAAAA//8DAFBLAwQUAAYACAAAACEAz5RhdBYEAABPEAAADQAAAHhsL3N0eWxlcy54bWzUWN1u2zYUvh+wdxB4r0hyLNc2LBexHQ0F2qJAMmC3tETZxPgjUHRmd+hN+kC7GbC+T4A9xw4pyVIW21EdrMVyY/GI/M53fnWYyestZ84dUQWVIkLBhY8cIhKZUrGK0M+3sTtETqGxSDGTgkRoRwr0evrjD5NC7xi5WROiHYAQRYTWWudjzyuSNeG4uJA5EfAmk4pjDUu18opcEZwW5hBnXs/3Bx7HVKASYcyTLiAcq183uZtInmNNl5RRvbNYyOHJ+M1KSIWXDKhugz5OnG0wUL1agxU9UcJpomQhM30BoJ7MMpqQp1xH3sjDSYMEsOchBaHn90rDp5NMCl04idwIHaFXqBRMJ8VH5w4zCEiAvOkkkUwqR62WEYpj3/4ZscCclNvmmNGlokZo3V+JOQVnGKFn1HTAju3fY+y/v3x5uP/z4f6vh8+fH+7/OA7Xa6hqSAGIgCXfsLxSFDOzKcOcsl1J3Z46zK8FWNleWv+Y39eiPvXoIatbHu3ItlukOnuzG9y7G+fDT1KvaXLKr9a9BfidMrZPtr5JNhBMJ1BHmigRw8Kpnm93OcRPQMmX8bb7ntm9UngX9MLuBwrJaGpYrOaHE3x57IXXomyyuwu9I9ri67g3nxnS/9LWvDiozSoFny6lSqF91iUcgj2laDphJNOAq+hqbX61zI0WqTV0mekkpXglBWamPOsTh05C+4VOGyEIsgDwI73As1q+WklHcGNJZcg3ocNJSjf8hLUvIVRbsMZUnVAB4aqj1fFEGdrnI/sNnP5dbKzSGIoiIYzdmLT9JdtXRgC+3maO2PCY6zdphGDUMJ+l+hFquHosq6BcmOpoo5XYLdjhWbDONquU4Txnuxh4mM+VY1dXjK4EJ6UICBxjDftN5zFAMGE0rEF+Ct702UbZzPaPI8qnE/iwl1yctVT0I/A0Y0EC5IhCZnDTNGlLflM4vyVba43x3TY7zh9I1/wv2/zNuHTCPWfyfxlXIPi/4do/khdgw/fKi+dSIWwoQ1k2qQymnKLcOXmfBP8gof6oaQmDrozeb/iSqNheM5oyelzR5/N0ni2oNunObvxvSdfOtZ0TemWrIT9qx/vG6pghPULvjRNZK+TLDWWaigOtGDDTbdPcfTNAaXPvsm1/rwWSKSUZ3jB9u38Zoeb5nf3QQ8Opdn2gd1JbiAg1z2/NBBUMjA5obW8LmEXg19koGqHfr2evRgsY4tyhPxu6/UsSuqNwtnDD/ny2WMQjv+fPP7UugC+4/tnLKvTToD8uGFwSVWVsRf6mkUWotSjp27kYaLe5j3oD/yoMfDe+9AO3P8BDdzi4DN04DHqLQX92HcZhi3t45oXT94KgvnBug3CsKSeMijpWdYTaUggSLE8Y4dWR8Jr/BEz/AQAA//8DAFBLAwQUAAYACAAAACEA8kqT1mkCAABCBQAAGAAAAHhsL3dvcmtzaGVldHMvc2hlZXQxLnhtbIxUy27jIBTdjzT/gNjX2M6rjeJUbdJqshipms5jTTCOUcB4gDz693OB2s1jFt1YGM459557L8zuj0qiPTdW6KbAWZJixBumS9FsCvzr5/PNLUbW0aakUje8wG/c4vv51y+zgzZbW3PuECg0tsC1c+2UEMtqrqhNdMsbOKm0UdTBr9kQ2xpOy0BSkuRpOiaKigZHhan5jIauKsH4UrOd4o2LIoZL6iB/W4vWdmqKfUZOUbPdtTdMqxYk1kIK9xZEMVJsuto02tC1BN/HbEhZpx1+ruSVYEZbXbkE5EhM9NrzHbkjoDSflQIc+LIjw6sCP2TTpxyT+SzU57fgB3uyRo6uX7nkzPES2oSRL/9a660HrmArBUUbAF6RMif2fMGlLPDjBDr4N8SAJQQgfYTTdRftOTTsxaCSV3Qn3ULLP6J0NUQdJsN8NLnN8hHuTn/owzcuNrWDY9hlO+u06nd8NKYlSMMXKeEnDApLj9FClM3TJBumYy8a6V24d3bk5e88QB0ib5CepHPNJDFw8Lqkjs5nRh8QzBhkYFvqJzabgppPfTRIPsJ/ZA9pe8KDZwQeQC3UeT9PZ2QPxWPviMeIgBx7xPAcsYiIwQlidI5YXiPG54ina8SkRxBw11uERC4tZrfJ5D8N6ix6RoGHwVx2YS6ewRT15gYX5iJiFNhwrS+MxdPxCf8iAsy9j36KyC+MxZmNfWzphn+nZiMaiySvIKs0gexMHMOwdroNu+B4rR2MZPdXwwPEoafwzFVau7iEKfWar9ztWqSNgIclvCcFbrVxhgoH6lMBt8ysyixcof71m/8DAAD//wMAUEsDBBQABgAIAAAAIQDsK8bolwEAAAQDAAAQAAgBZG9jUHJvcHMvYXBwLnhtbCCiBAEooAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJySTW7bMBCF9wVyB4H7mHJSBIVBMSjygyxa1ICdZM1QI4sITQqciWB3WxToDbLtFbrtfVL0GB1JiCM3XXU3Pw+PHx+pTjdrn7WQ0MVQiOkkFxkEG0sXVoW4Xl4evhMZkgml8TFAIbaA4lQfvFHzFBtI5AAztghYiJqomUmJtoa1wQmvA2+qmNaGuE0rGavKWTiP9mENgeRRnp9I2BCEEsrDZmcoBsdZS/9rWkbb8eHNctswsFbvm8Y7a4hvqT86myLGirKLjQWv5HipmG4B9iE52upcyXGrFtZ4OGNjXRmPoOTLQF2B6UKbG5dQq5ZmLViKKUP3mWM7EtmdQehwCtGa5EwgxupkQ9PXvkFK+jame6wBCJVkwTDsy7F2XLu3etoLuNgXdgYDCC/2EZeOPOCnam4S/YN4OibuGQbeAefp5+Pvb4+/vnx9+v7jFWV/cT7vrxM+uHCP180ynhuC5wT3h2pRmwQlh75LeDdQVxxe8p3JWW3CCspnzetF9943w6fW05NJfpzzU45mSr58X/0HAAD//wMAUEsDBBQABgAIAAAAIQANG8RsZAEAAGQCAAARAAgBZG9jUHJvcHMvY29yZS54bWwgogQBKKAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB8kt9KwzAUxu8F36Hkvk3/bGOGtgOV4YUTwYriXUjOumKbliS67R18BEV8Bi/0hWQ+hmm71Yoi5Cb5vvM73zkknKyK3LoHqbJSRMhzXGSBYCXPRBqhy2Rqj5GlNBWc5qWACK1BoUm8vxeyirBSwrksK5A6A2UZklCEVRFaaF0RjBVbQEGVYxzCiPNSFlSbq0xxRdktTQH7rjvCBWjKqaa4BtpVR0RbJGcdsrqTeQPgDEMOBQitsOd4+NurQRbqz4JG6TmLTK8rM9M2bp/NWSt27pXKOuNyuXSWQRPD5Pfw9ez0ohnVzkS9KwYoDjkjTALVpYw3r+8fb0+bx+fPl4cQ94R6iTlVemb2Pc+AH67jk5KK9GwW4t+SQTYTtFzglslE2gl2ylVwdJxMUey7vme7Q9s9SPyADMZkMLypO/+orzO2D8W2///EwHbrk3ge8UckGPSIO0Dc5P75L+IvAAAA//8DAFBLAwQUAAYACAAAACEAz+BHtMIBAAAsFQAAJwAAAHhsL3ByaW50ZXJTZXR0aW5ncy9wcmludGVyU2V0dGluZ3MxLmJpbuxUzUrcUBg9M7Ht6KYOFNx0UaQrcegMk6ndVZmkdkrShCQzuHExdFIIjMmQRESlgvgaPkiXLl32Abp2IcUHcKPnpjPYlqGM4Eb47uW73889OTf3kHw2InxBigQZ7StyvILLPEJcxDmrqmLgA6aN0pz29CfcF9qbEtS8XEgqA/rn2CqX6bfKGlcLIdlyrulUlvsVS2O48mWa8jccmx1f/5PJ6HzuLuMcr7XV6vvtw6P/nfKk2JwvuB7gFYXiESow+a5mefVzgnw7+KSwi/iOQ9TxDjr/kjoaXDdQg4m3aLJWoxlY46wR02TdZFRnrjNv0LeZNdEqsm9k9EzfsCx04ygNMxW5/VGY+tFBCMsMAtODk0ZhnPfzKInhOl7gbXQCeGGWDHeLGkNnpKIG2skwSe1kEP6O/r7dahXo6YY9ufvpwmj5JSG/aBrtuuRU9Is9++Tq2cels9bxD9as8R4qd1wKq/KVsVf5Oq2n8kXw/gn7zC522ANUZ+my36hu4KLPKMMe91MMCP4X6XAvnhHbJsc+RuT3+YQ6T3WynDUZooAoIAqIAqKAKCAKiAKigCggCogCooAoIArMosAtAAAA//8DAFBLAwQUAAYACAAAACEAliXxru4AAADpAAAACwAAAHhsL21ldGFkYXRhAekAFv8AxRbaZfzL6r+A1P4vuRjlIn/5jDQy+TB72ZKl/48XZu7sCugOzzE0sR7Bm2ofRm9JGm9uWXsowLQSBoP/ey3tRgpAGU0Vnn07a9jub9qCEBO/F3OiQHSEWwpQckfaFhQf1whoE1a+x8fiQnWv2sA+fSBNnEqkvdomykkQYIm9TalPMjMdccE9xeQyWPOUdGXd2qOjF+/10q+0/jObLIf6qpHf6VogvwLZh6SK5n66TvKVjjoyvdWRt95wsaGFHH6YLTOaClv9P0ZrBJdnXm3VxFiuUO/JN322CDf5o3C0c8HZtHK95bOd3FBLAQItABQABgAIAAAAIQCEreWPfgEAAEgFAAATAAAAAAAAAAAAAAAAAAAAAABbQ29udGVudF9UeXBlc10ueG1sUEsBAi0AFAAGAAgAAAAhALVVMCP0AAAATAIAAAsAAAAAAAAAAAAAAAAAtwMAAF9yZWxzLy5yZWxzUEsBAi0AFAAGAAgAAAAhAJisVKcWAQAAKwMAABoAAAAAAAAAAAAAAAAA3AYAAHhsL19yZWxzL3dvcmtib29rLnhtbC5yZWxzUEsBAi0AFAAGAAgAAAAhALipIOpcAgAAggQAAA8AAAAAAAAAAAAAAAAAMgkAAHhsL3dvcmtib29rLnhtbFBLAQItABQABgAIAAAAIQC4ShWWJgEAALUBAAAUAAAAAAAAAAAAAAAAALsLAAB4bC9zaGFyZWRTdHJpbmdzLnhtbFBLAQItABQABgAIAAAAIQA7bTJLwQAAAEIBAAAjAAAAAAAAAAAAAAAAABMNAAB4bC93b3Jrc2hlZXRzL19yZWxzL3NoZWV0MS54bWwucmVsc1BLAQItABQABgAIAAAAIQDNsykToAMAAJUOAAATAAAAAAAAAAAAAAAAABUOAAB4bC90aGVtZS90aGVtZTEueG1sUEsBAi0AFAAGAAgAAAAhAM+UYXQWBAAATxAAAA0AAAAAAAAAAAAAAAAA5hEAAHhsL3N0eWxlcy54bWxQSwECLQAUAAYACAAAACEA8kqT1mkCAABCBQAAGAAAAAAAAAAAAAAAAAAnFgAAeGwvd29ya3NoZWV0cy9zaGVldDEueG1sUEsBAi0AFAAGAAgAAAAhAOwrxuiXAQAABAMAABAAAAAAAAAAAAAAAAAAxhgAAGRvY1Byb3BzL2FwcC54bWxQSwECLQAUAAYACAAAACEADRvEbGQBAABkAgAAEQAAAAAAAAAAAAAAAACTGwAAZG9jUHJvcHMvY29yZS54bWxQSwECLQAUAAYACAAAACEAz+BHtMIBAAAsFQAAJwAAAAAAAAAAAAAAAAAuHgAAeGwvcHJpbnRlclNldHRpbmdzL3ByaW50ZXJTZXR0aW5nczEuYmluUEsBAi0AFAAGAAgAAAAhAJYl8a7uAAAA6QAAAAsAAAAAAAAAAAAAAAAANSAAAHhsL21ldGFkYXRhUEsFBgAAAAANAA0AXwMAAEwhAAAAAA=="
                  download="batch_gochi_charge_sample_file.xlsx"
                  // eslint-disable-next-line react/jsx-no-target-blank
                  target="_blank"
                >
                  EXCELフォーマットダウンロード
                </a>
                <div className={classes.flexRow}>
                  <input
                    type="file"
                    onChange={e => {
                      setFile(e.target.files[0]);
                    }}
                    onClick={e => {
                      e.target.value = '';
                    }}
                  />
                  <BatchGochiChargeButton
                    onClickAction={validateAction}
                    registerAction={registerAction}
                    name="登録"
                    validateData={validateData}
                    openConfirm={openConfirm}
                    updateOpenConfirm={updateOpenConfirm}
                    classes={classes}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={classes.horizotalLine} />
          {openTable && (
            <BatchGochiChargeTable
              page={page}
              handleChangePage={handleChangePage}
              setResultMessage={setResultMessage}
              progress={progress}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              updateOpenProgress={updateOpenProgress}
              updateLoading={updateLoading}
            />
          )}
        </Paper>

        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
